var MainNavFlyoutItem, MainNavMenuItem, MainNavViewModel;

MainNavFlyoutItem = (function() {
  function MainNavFlyoutItem(options) {
    options = $.extend({
      isNew: false,
      isBeta: false,
      isAdmin: false
    }, options);
    this.isNew = ko.asObservable(options.isNew);
    this.isBeta = ko.asObservable(options.isBeta);
    this.isAdmin = ko.asObservable(options.isAdmin);
    this.isSelected = ko.observable(false);
    this.hasRibbon = ko.pureComputed((function(_this) {
      return function() {
        return _this.isNew() || _this.isBeta();
      };
    })(this));
    this.ribbonText = ko.pureComputed((function(_this) {
      return function() {
        if (_this.isBeta()) {
          return 'beta';
        }
        if (_this.isNew()) {
          return 'new';
        }
      };
    })(this));
    this.id = options.id;
    if (this.id == null) {
      throw 'A Flyout Menu Item must have an id.';
    }
    this.name = ko.asObservable(options.name);
    if (this.name() == null) {
      throw 'A Flyout Menu Item must have a name.';
    }
    this.href = ko.asObservable(options.href);
    if (this.href() == null) {
      throw 'A Flyout Menu Item must have a href.';
    }
    this.description = ko.asObservable(options.description);
  }

  return MainNavFlyoutItem;

})();

MainNavMenuItem = (function() {
  MainNavMenuItem.prototype.toggleFlyout = function(item) {
    return item.isFlyoutOpen(!item.isFlyoutOpen());
  };

  function MainNavMenuItem(options) {
    options = $.extend({
      iconId: '#icon-circle-o',
      name: 'unknown'
    }, options);
    this.id = options.id;
    if (this.id == null) {
      throw "A Menu Item must provide an ID.";
    }
    this.name = ko.asObservable(options.name);
    if (this.name() == null) {
      throw "A Menu Item must provide a name.";
    }
    this.icon = ko.asObservable(options.iconId);
    this.isFlyoutOpen = ko.observable(false);
    this.isSelected = ko.observable(false);
    this.href = ko.asObservable(options.href);
    this.rawFlayoutItems = ko.asObservableArray(options.items);
    this.adminFlyoutItems = ko.observableArray([]);
    this.normalFlyoutItems = ko.observableArray([]);
    ko.computed((function(_this) {
      return function() {
        return _this.rawFlayoutItems().forEach(function(f) {
          if (f.isAdmin) {
            return _this.adminFlyoutItems.push(new MainNavFlyoutItem(f));
          } else {
            return _this.normalFlyoutItems.push(new MainNavFlyoutItem(f));
          }
        });
      };
    })(this));
    if ((ko.unwrap(options.href) != null) && (ko.unwrap(options.items) != null)) {
      throw "The Menu Item with name '" + (this.name()) + "' has defined both a href and has Flyout Menu Items. This is not allowed please choose one or the other.";
    }
    this.templateName = ko.pureComputed((function(_this) {
      return function() {
        if (_this.href() == null) {
          return 'cyclops.mainNav.menuItem.button';
        } else {
          return 'cyclops.mainNav.menuItem.href';
        }
      };
    })(this));
  }

  return MainNavMenuItem;

})();

MainNavViewModel = (function() {
  function MainNavViewModel(options, element) {
    var $mainNav, $window, calculateMainNavPosition, closeTimer, mainNavOriginalTopPosition, renderTimeout, selectAnItem;
    options = $.extend({
      menus: [],
      loading: false,
      error: false
    }, options);
    $mainNav = $(element);
    $window = $(window);
    mainNavOriginalTopPosition = $mainNav.position().top;
    calculateMainNavPosition = function() {
      var newTopPosition;
      newTopPosition = mainNavOriginalTopPosition - $window.scrollTop();
      if (newTopPosition < 0) {
        newTopPosition = 0;
      }
      return $mainNav.css({
        'top': newTopPosition
      });
    };
    calculateMainNavPosition();
    $window.on('scroll', calculateMainNavPosition);
    this.updateMainMenuScrollIcons = function() {
      var $down, $items, $up;
      $items = $mainNav.find('.main-nav-menu-items');
      $up = $mainNav.find('.scroll-up');
      $down = $mainNav.find('.scroll-down');
      if ($items.scrollTop() + $items.innerHeight() >= $items[0].scrollHeight) {
        if ($down.is(':visible')) {
          $down.stop().fadeOut();
        }
      } else {
        if ($down.is(':hidden')) {
          $down.stop().fadeIn();
        }
      }
      if ($items.scrollTop() === 0) {
        return $mainNav.find('.scroll-up').fadeOut();
      } else {
        return $mainNav.find('.scroll-up').fadeIn();
      }
    };
    $mainNav.find(".main-nav-menu-items").on('scroll', this.updateMainMenuScrollIcons);
    $window.on('resize', this.updateMainMenuScrollIcons);
    this.scrollDownHandler = function(data, event) {
      var $items;
      $items = $mainNav.find('.main-nav-menu-items');
      return $items.scrollTop($items.scrollTop() + 26);
    };
    this.scrollUpHandler = function(data, event) {
      var $items;
      $items = $mainNav.find('.main-nav-menu-items');
      return $items.scrollTop($items.scrollTop() - 26);
    };
    this.isLoading = ko.asObservable(options.loading);
    this.hasErrored = ko.asObservable(options.error);
    this.rawMenus = ko.asObservable(options.menus);
    renderTimeout = null;
    this.menus = ko.pureComputed((function(_this) {
      return function() {
        var result;
        result = _this.rawMenus().reduce(function(menus, menu) {
          if ((menu.href != null) || (menu.items && ko.unwrap(menu.items).length > 0)) {
            menus.push(new MainNavMenuItem(menu));
          }
          return menus;
        }, []);
        if (renderTimeout) {
          window.clearTimeout(renderTimeout);
        }
        renderTimeout = window.setTimeout(_this.updateMainMenuScrollIcons, 500);
        return result;
      };
    })(this));
    this.SelectedItemId = ko.asObservable(options.selectedItemId);
    selectAnItem = (function(_this) {
      return function(itemId) {
        return _this.menus().forEach(function(m) {
          if (m.id === itemId) {
            return m.isSelected(true);
          } else {
            m.isSelected(false);
            m.normalFlyoutItems().forEach(function(f) {
              if (f.id === itemId) {
                m.isSelected(true);
                return f.isSelected(true);
              } else {
                return f.isSelected(false);
              }
            });
            return m.adminFlyoutItems().forEach(function(f) {
              if (f.id === itemId) {
                m.isSelected(true);
                return f.isSelected(true);
              } else {
                return f.isSelected(false);
              }
            });
          }
        });
      };
    })(this);
    this.SelectedItemId.subscribe(selectAnItem);
    this.menus.subscribe((function(_this) {
      return function() {
        return selectAnItem(_this.SelectedItemId());
      };
    })(this));
    selectAnItem(this.SelectedItemId());
    this.selectFlyout = (function(_this) {
      return function(menu) {
        var previousState;
        previousState = menu.isFlyoutOpen();
        _this.menus().forEach(function(m) {
          return m.isFlyoutOpen(false);
        });
        if (!previousState) {
          return menu.isFlyoutOpen(!previousState);
        }
      };
    })(this);
    $('body > *').not('main-nav').on('click', (function(_this) {
      return function() {
        return _this.menus().forEach(function(m) {
          return m.isFlyoutOpen(false);
        });
      };
    })(this));
    closeTimer = void 0;
    $mainNav.hover((function(_this) {
      return function() {
        if (closeTimer) {
          return window.clearTimeout(closeTimer);
        }
      };
    })(this), (function(_this) {
      return function() {
        return closeTimer = window.setTimeout(function() {
          return _this.menus().forEach(function(m) {
            return m.isFlyoutOpen(false);
          });
        }, 1000);
      };
    })(this));
    $mainNav.addClass('loaded');
  }

  return MainNavViewModel;

})();
